import Typography from '@mui/material/Typography';
import React, { useDeferredValue } from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { SearchInput } from 'shared/components/ui/search-input';
import { useDelayedCallback } from 'shared/hooks/use-delayed-callback';
import { QueryParamOptions, useQueryParam } from 'shared/lib/react-router-dom';

import * as Styled from './page-top-bar.style';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useQueryParam(QueryParamOptions.Search);

  const _setSearchText = (value: string) => setSearchText(value, true);
  const [onChangeSearch] = useDelayedCallback(_setSearchText, 350);

  const onClear = () => setSearchText(undefined, true);

  const deferredSearchText = useDeferredValue(searchText);

  return (
    <TopBarBase>
      <Styled.Container>
        <Styled.Title>
          <Typography variant="h6" component="h1">
            {t('pages.search.title')}
          </Typography>
        </Styled.Title>

        <Styled.InteractionsContainer>
          <SearchInput
            value={deferredSearchText}
            onChange={onChangeSearch}
            onClear={onClear}
            placeholder={t('general.labels.search.placeholder')}
            isAlternative
            preventDrag
          />
        </Styled.InteractionsContainer>
      </Styled.Container>
    </TopBarBase>
  );
};
